import React, { useState} from 'react'
import CardMenu from '../../components/CardMenu/CardMenu'
import { Link } from 'react-router-dom'
import { BasicLayout } from '../../modules/Layouts/basicLayout'
import { setActiveModuleDoc } from '../../actions/documentos/documentos.actions'
import { BannerElegirSucursal } from '../../components/Banner/BannerElegirSucursal'
import { useDispatch } from 'react-redux'
import './styles/otros-documentos.css'

const cards = [
  {
    titulo: 'Cierre de período fiscal',
    descripcion: 'En esta opción podrá realizar un cierre fiscal y descargar todos los documentos emitidos en el periodo correspondiente.',
    to: '/mas-opciones/cierre-periodo-fiscal',
    activo: 5,
    id: '11',
    disabled: false,
    autoFocus: true,
  },
  {
    titulo: 'Libro de IVA para ventas',
    descripcion: 'En esta opción podrá gestionar el libro de IVA para ventas, permitiendo la consolidación y descarga de todos los registros fiscales correspondientes al período seleccionado.',
    to: '/mas-opciones/libro-ventas',
    activo: 6,
    id: '12',
    disabled: false,
    autoFocus: true,
  },
  {
    titulo: 'Libro de IVA para compras',
    descripcion: 'En esta opción podrá gestionar el libro de IVA para compras, permitiendo la carga, consolidación y descarga de todos los registros fiscales correspondientes al período seleccionado.',
    to: '/mas-opciones/libro-compras',
    activo: 7,
    id: '13',
    disabled: false,
    autoFocus: true,
  },
  {
    titulo: 'Bitácora de correos',
    descripcion: 'En esta opción podrá llevar el control del estatus de los correos realizados.',
    to: '/mas-opciones/bitacora-correos',
    activo: 8,
    id: '14',
    disabled: false,
    autoFocus: true,
  },
]

const MasOpcionesIndex = () => {
  const [activo, setActivo] = useState(0)
  const dispatch = useDispatch()

  const handleActiveDoc = (card: any) => {
    dispatch(setActiveModuleDoc({title: card.titulo, idDoc: card.id}))
  }

  return (
    <BasicLayout>
      <div className='header-link'>
        <Link to={'/home'} className='back-button w-inline-block'></Link>
        <h3 className='h3-titles xl'>Más opciones</h3>
      </div>
      <div className='separador'></div>
      <BannerElegirSucursal />
      <div className='otros-documents-grid3-columns home-dashboard'>
        {cards.map((card, i) => (
          <CardMenu
            key={i}
            className='otros-documents-card'
            classNameH2='otros-documents-card-title'
            to={card.to}
            activar={() => setActivo(card.activo)}
            desactivar={() => setActivo(0)}
            activo={activo === card.activo}
            title={card.titulo}
            description={card.descripcion}
            onClick={() => {
              handleActiveDoc(card)
            }}
            autoFocus={card.autoFocus}
            disabled={card.disabled}
          />
        ))}
      </div>
    </BasicLayout>
  )
}

export default MasOpcionesIndex
